const $ = jQuery.noConflict();

'use strict';
const ContactFormScroll = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {

		document.addEventListener('wpcf7invalid', function() {
			setTimeout(function() {
				$('html').stop().animate({
					scrollTop: $('.wpcf7-not-valid').eq(0).offset().top - 180,
				}, 500, 'swing');
			}, 100);
		}, false);
	},
};

export default ContactFormScroll;
